import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';

// The form layout the whole console shares (R-304).
//
// Before this existed the same three-line stack was copy-pasted into 21
// feature `*.styles.ts` files, and the copies had drifted to FOUR different
// widths — `maxWidth: 420px` ×6, `440px` ×2, `460px` ×1, and none at all ×12 —
// while every one of them renders inside the same `ui/Modal` at the same default
// 600px. Measured in the asset Move dialog: dialog 598px, form 420px, so every
// field carried a 138px dead gutter, and a different gutter per module. That was
// the whole "the forms have inconsistent gaps and sizes" report.
export const styles = {
  form: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1bof9c1",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  narrow: {
    ks0D6T: "x1pfbilc",
    $$css: true
  },
  row: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x1o61qjw xreyasp",
    kOIVth: "x1bof9c1",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  rowThirds: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x1rp53t7 xreyasp",
    kOIVth: "x1bof9c1",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  actions: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1mnnc3i",
    keoZOQ: "xv1leuy",
    $$css: true
  },
  actionsEnd: {
    kjj79g: "x13a6bvl",
    $$css: true
  },
  actionsBetween: {
    kjj79g: "x1qughib",
    $$css: true
  },
  actionsDivided: {
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "x1p7xzfl",
    kLKAdn: "x1eonmf3",
    $$css: true
  }
};